var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-header border-0"},[_c('h5',{staticClass:"card-title"},[_vm._v("کمپین فروش")])]),_c('div',{staticClass:"card-body"})])
}]

export { render, staticRenderFns }